import { styled } from "@mui/material/styles";
import { VariantType } from "notistack";

interface CoreToastTextProps {
	variant: VariantType;
}

export const CoreToastText = styled('div')<CoreToastTextProps>(({ theme }) => ({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	rowGap: '4px',
}));
